import { Fragment, useState } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Email, LetterBoxTitle } from "../../../Constants/Constants";
import EmailRightSide from "./EmailRightSide/EmailRightSide";
import EmailSidebar from "./EmailSidebar/EmailSidebar";

const LetterBoxContainer = () => {
  const [navId, setNavId] = useState("1");
  return (
    <Fragment>
      <Breadcrumbs mainTitle={LetterBoxTitle} parent={Email} />
      <Container fluid>
        <div className="email-wrap email-main-wrapper">
          <Row>
            <EmailSidebar navId={navId} setNavId={setNavId} />
            <EmailRightSide navId={navId} />
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default LetterBoxContainer;
